module.exports = __webpack_public_path__ + "static/img/section_six_in_one_bg.a8dd4a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rescuelist/section_six_in_one_bg.png
// module id = 7QjI
// module chunks = 1